import mongoose from "mongoose"

import { getMongoDirectConnection, getMongoUrl } from "./getMongoUrl"


const connections = new Map<string, mongoose.Connection>()
let rootConnection: mongoose.Connection | null = null
const CONNECTION_MAX_LISTENERS = 50

const waitForOpen = async (connection: mongoose.Connection): Promise<void> => {
  if (connection.readyState === 1) return
  if (connection.getMaxListeners() < CONNECTION_MAX_LISTENERS) {
    connection.setMaxListeners(CONNECTION_MAX_LISTENERS)
  }

  await new Promise<void>((resolve, reject) => {
    connection.once("open", resolve)
    connection.once("error", reject)
  })
}

export const ensureMongooseConnection = async (dbName: string): Promise<mongoose.Connection> => {
  const normalizedDbName = dbName.trim()
  if (!normalizedDbName) {
    throw new Error("Missing dbName")
  }

  const existing = connections.get(normalizedDbName)
  if (existing) {
    await waitForOpen(existing)
    return existing
  }

  if (!rootConnection) {
    const mongoUrl = getMongoUrl()
    rootConnection = mongoose.createConnection(mongoUrl, {
      sanitizeFilter: true,
      dbName: normalizedDbName,
      directConnection: getMongoDirectConnection(),
    })
  }

  await waitForOpen(rootConnection)

  const connection = rootConnection.name === normalizedDbName
    ? rootConnection
    : rootConnection.useDb(normalizedDbName, { useCache: true })

  await waitForOpen(connection)

  connections.set(normalizedDbName, connection)
  return connection
}
